/* Moments Etched v15.2.6 — persistent accessible single-select catalog color swatches */
(() => {
  'use strict';
  const fallback = {
    'baby-pink':'#f3b6c8','black':'#111111','burgundy':'#5f1d2d','camo':'#5f6348','charcoal':'#3f3f3f','charcoal-heather':'#555555','coral':'#f06f61','dark-navy':'#18233a','decadent-chocolate':'#4a2f26','denim':'#4f6f8f','dust':'#cfc3b7','gold':'#f2b233','hot-pink':'#e83e8c','kelly-green':'#237a45','lavender':'#b9a6d3','lime-green':'#8cc63f','maroon':'#672e45','military-green':'#4b5435','mint':'#a8d5ba','moss-green':'#59633f','mustard':'#c6973f','navy':'#1f2a44','neon-orange':'#ff671f','orange':'#ff6a39','pacific-blue':'#3c8fb5','peach':'#f3be8d','pink':'#f7ced7','powder-blue':'#b8d7e8','purple':'#5b3f86','red':'#e10600','royal':'#24509a','rust':'#9e483f','salt-pepper':'#8d8a84','sand':'#d8c3a5','sawana-brown':'#8a5f3f','sports-grey':'#b8b8b8','sport-grey':'#b8b8b8','teal':'#007f7a','texas-orange':'#bf5700','turquoise':'#40b5ad','white':'#ffffff','yellow':'#f1c84b'
  };
  const key = value => String(value || '').trim().toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  const colors = () => ({...fallback, ...(window.ME_COLOR_LIBRARY?.['af-apparel'] || {})});
  const allFacets = scope => {
    const list = [];
    if (scope?.matches?.('.facets__panel')) list.push(scope);
    scope?.querySelectorAll?.('.facets__panel').forEach(f => list.push(f));
    return list;
  };
  const isColorFacet = facet => ['color','colour'].includes(String(facet.querySelector('.facets__label')?.textContent || '').trim().toLowerCase());

  function expandColor(facet) {
    const button = facet.querySelector('.show-more__button, [data-show-more] button');
    if (button && (button.getAttribute('aria-expanded') === 'false' || /show more/i.test(button.textContent || ''))) {
      try { button.click(); } catch (_) {}
    }
    if (button) { button.hidden = true; button.setAttribute('aria-hidden','true'); button.tabIndex = -1; }
    facet.querySelectorAll('.facets__inputs-list-item').forEach(item => {
      item.hidden = false;
      item.classList.remove('hidden','is-hidden');
      item.style.removeProperty('display');
    });
  }

  function enhanceFacet(facet) {
    if (!isColorFacet(facet)) return;
    facet.classList.add('me-facet--color','me-facet--always-expanded');
    expandColor(facet);
    facet.querySelectorAll('.checkbox').forEach(box => {
      const input = box.querySelector('input[type="checkbox"]');
      const visual = box.querySelector('.checkbox__label');
      const text = box.querySelector('.checkbox__label-text');
      if (!input || !visual) return;
      const name = input.dataset.label || input.value || text?.textContent || 'Color';
      box.dataset.meColorFacet = 'true';
      box.dataset.meColorName = name;
      box.style.setProperty('--me-facet-swatch', colors()[key(name)] || '#c9c4bd');
      visual.title = name; visual.dataset.meColorName = name;
      if (!visual.getAttribute('aria-label')) visual.setAttribute('aria-label', name);
    });
  }

  function enhance(scope=document) {
    if (document.querySelector('.me-catalog-header-section')) document.body.classList.add('me-catalog-native-template');
    allFacets(scope).forEach(enhanceFacet);
  }

  let timer;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(() => enhance(document), 20);
  };
  const boot = () => {
    enhance(document);
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load', schedule);
    /* Color is intentionally single-select. Clicking any part of a swatch replaces the current color filter. */
    document.addEventListener('click', e => {
      const box = e.target.closest?.('.me-facet--color .checkbox');
      if (!box) return;
      const input = box.querySelector('input[type="checkbox"]');
      if (!input || input.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const url = new URL(window.location.href);
      const colorParams = [...url.searchParams.keys()].filter(name => /filter\.v\.option\.color/i.test(name));
      const currentValues = colorParams.flatMap(name => url.searchParams.getAll(name));
      const isCurrent = currentValues.some(v => String(v) === String(input.value));
      colorParams.forEach(name => url.searchParams.delete(name));
      if (!isCurrent) url.searchParams.append(input.name || 'filter.v.option.color', input.value);
      url.hash = 'choose-apparel';
      window.location.assign(url.toString());
    }, true);
    document.addEventListener('change', e => { if (e.target.closest?.('.facets')) setTimeout(() => enhance(document), 80); }, true);
    window.addEventListener('popstate', schedule);
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
})();
